<template>
  <div>
    <clouded-glass class="main">
      <div slot="content">
        <div :class="deviceInfo.status === 0 ? 'green' : 'red'" class="status"></div>
        <div class="logo">
          <div v-if="!deviceShowBrand" class="hidden_brand"></div>
          <div v-if="!deviceShowModel" class="hidden_model"></div>
          <img :src="$ftpUrl + deviceInfo.iconTopological" alt="" class="logo-img">
        </div>
        <div class="name">{{ deviceInfo.name }}</div>
        <div class="cross-line"></div>
        <div class="brand" v-if="deviceShowBrand"><span class="text-blueGrey">品牌：</span><span>{{
            deviceInfo.brandCnName
          }}</span></div>
        <div class="model" v-if="deviceShowModel"><span class="text-blueGrey">型号：</span><span>{{
            deviceInfo.modelCnName
          }}</span></div>
      </div>
    </clouded-glass>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";

export default {
  name: "DeviceShowComp",
  components: {CloudedGlass},
  props: {
    deviceInfo: {},
    deviceShowBrand: {
      type: Boolean,
      default: () => true
    },
    deviceShowModel: {
      type: Boolean,
      default: () => true
    },
  }
}
</script>

<style scoped>
.main {
  width: 243px;
  height: 288px;
  background: rgba(0, 0, 0, 0);
}

.content:hover {
  cursor: pointer;
}

.status {
  float: left;
  margin: 20px 0 0 24px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  opacity: 1;
}

.green {
  background: #15DEB5;
}

.red {
  background: #FF8373;
}

.logo {
  clear: both;
  width: 100%;
  text-align: center;
}

.logo-img {
  margin: 24px auto 0 auto;
  width: 64px;
  height: 54px;
  opacity: 0.7;
  background: rgba(0, 0, 0, 0);
}

.name {
  text-align: center;
  width: 100%;
  margin: 17px 0 0 0;
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
}

.cross-line {
  width: 60%;
  margin: 20px auto;
  height: 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.2;
}

.hidden_brand,
.hidden_model,
.model,
.brand {
  margin: 6px;
  text-align: center;
  /*width: 100%;*/
  height: 19px;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

</style>
